<template>
  <div>
    <Suspense>
      <template #default>
        <div v-if="isReady">
          <div v-show="dashboardType === 'office'">
            <OfficeDashboard />
          </div>
          <div v-show="dashboardType === 'warehouse'">
            <WarehouseDashboard />
          </div>
          <div v-show="dashboardType === 'crew'">
            <CrewDashboard />
          </div>
          <div v-show="dashboardType === 'finance'">
            <FinanceDashboard />
          </div>
          <div v-show="dashboardType === 'workshop'">
            <WorkshopDashboard />
          </div>
          <div v-show="dashboardType === 'logistics'">
            <LogisticsDashboard />
          </div>
          <div v-show="dashboardType === 'shooting'">
            <ShootingDashboard />
          </div>
          <div v-show="dashboardType === 'freelance'">
            <FreelanceDashboard />
          </div>
        </div>
      </template>
      <template #fallback>
        <div
          class="flex justify-content-center align-items-center"
          style="height: 200px"
        >
          <i
            class="pi pi-spin pi-spinner"
            style="font-size: 2rem"
          />
        </div>
      </template>
    </Suspense>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick, watch } from 'vue';
import { useRoute } from 'vue-router';

// Import all dashboard components
import OfficeDashboard from '@/pages/OfficeDashboard.vue';
import WarehouseDashboard from '@/components/dashboard/WarehouseDashboardComponent.vue';
import CrewDashboard from '@/components/dashboard/CrewDashboard.vue';
import FinanceDashboard from '@/components/dashboard/FinanceDashboard.vue';
import WorkshopDashboard from '@/components/dashboard/WorkshopDashboard.vue';
import LogisticsDashboard from '@/components/dashboard/LogisticsDashboard.vue';
import ShootingDashboard from '@/components/dashboard/ShootingDashboard.vue';
import FreelanceDashboard from '@/components/dashboard/FreelanceDashboard.vue';

// Reactive variables
const dashboardType = ref('office'); // default to office
const isReady = ref(false);
const route = useRoute();

// Function to update dashboard type based on route
const updateDashboardType = async () => {
    try {
        isReady.value = false;
        // Check route meta for dashboard type
        if (route.meta.dashboard) {
            dashboardType.value = route.meta.dashboard;
        } else if (typeof route.meta.showOffice === 'boolean') {
            // For backward compatibility with showOffice
            dashboardType.value = route.meta.showOffice ? 'office' : 'warehouse';
        }

        console.log('Current dashboard type:', dashboardType.value);

        // Ensure DOM is updated before any PrimeVue components initialize
        await nextTick();
        isReady.value = true;
    } catch (error) {
        console.error("Error setting dashboard type:", error);
    }
};

// Watch for route changes
watch(
    () => route.fullPath,
    () => updateDashboardType()
);

// Initial setup on mount
onMounted(() => updateDashboardType());
</script>
